
import { IComponentDecorator, IDecoratedProps, withDisplayName, IDecoratedComponentType } from '../../utilities/components/Decorators';
import { IItemCache } from '../../models/IItemCacheObserver';
import { connectToItemCache } from './connectToItemCache';
import { getItemsScope } from '../../models/itemsScope/getItemsScope';

/**
 * @public
 */
export interface IItemsScopeConnectorProps {
    itemsScopeItemKey?: string;
}

/**
 * @public
 */
export type IDecorateConnectToItemsScopeProps<TProps> = IDecoratedProps<TProps, IItemsScopeConnectorProps, {}>;

/**
 * @internal
 */
export { getItemsScope };

/**
 * @public
 */
export function connectToItemsScope(): IComponentDecorator<IItemsScopeConnectorProps, {}> {
    return <P extends IItemsScopeConnectorProps>(
        component: React.ComponentType<P>
    ): IDecoratedComponentType<P, IItemsScopeConnectorProps, {}> => {
        const Injected = connectToItemCache((itemCache: IItemCache): IItemsScopeConnectorProps => {
            return getItemsScope(itemCache);
        })(component);

        const Named = withDisplayName('ConnectToItemsScope')(Injected);

        return Named;
    };
}
